/* eslint-disable max-len */
/* eslint-disable react/jsx-key */
import React from "react";
import { useNavigate } from "react-router-dom";
import Noresult from "./Noresult";

export default function ViewMerchantList() {
    const addAdminNavigate = useNavigate();
    const data = [
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
        {
            merchant_name: "Fashion Haven Boutique",
            business_name: "ChicStyle Boutique",
            city: "London",
            postal_code: "SW1 AAA",
            number_of_stores: "03",
            status: "Inactive",
            action: "view",
        },
    ];
    const arr = [];
    const totaldata = arr.length;

    const CheckSort = (key) => searchParams.get('sort') !== null && searchParams.get('sort') === `${key}+asc`

    function getStatusContent(status) {
        switch (status) {
        case "Active":
            return [
                <div className="flex justify-center space-x-3 pl-[48px]">
                    <div className="flex space-x-1 items-center">
                        <img src="../../src/assets/images/Success.svg" alt="" />
                        <h1 key="status" className="text-sm font-normal text-[#1F1F1F]">
                            Active
                        </h1>
                    </div>
                    <div className="status custom-toggle flex items-center">
                        <label className="switch" style={{ marginLeft: "10px" }}>
                            <input type="checkbox" id="clock_in_out" checked />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>,
            ];
        case "Inactive":
            return [
                <div className="flex justify-center pl-[48px]">
                    <div className="flex space-x-1 items-center">
                        <img src="../../src/assets/images/close.png" alt="" />
                        <h1 key="status" className="text-sm font-normal text-[#1F1F1F]">
                            Inactive
                        </h1>
                    </div>
                    <div className="status custom-toggle flex items-center">
                        <label className="switch" style={{ marginLeft: "10px" }}>
                            <input type="checkbox" id="clock_in_out" />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>,
            ];
        default:
            return <h1 className="text-sm">Unknown</h1>;
        }
    }

    return (
        <div className="flex-grow ">
            <div className="py-[41px] pl-[32px] bg-white shadow-custom">
                <h1 className="font-playfair text-[#4B4B4B] text-xl font-medium">
                    Merchant
                </h1>
            </div>
            <div className="bg-[#f5f5f5] pl-[15px] pt-[15px] h-customh7 ">
                <div className="bg-white px-6 font-medium text-[#4B4B4B] h-full">
                    <div className="flex py-6 justify-between items-center pr-[66px]">
                        <h1 className="font-playfair text-xl">Merchant List</h1>
                        <div className="flex justify-center items-center space-x-10">
                            <div className="relative">
                                <input
                                    type="text"
                                    placeholder="Name, Email Address, Phone Number"
                                    className="w-[314px] h-10 rounded-[8px] pl-[14px] py-4 border border-[#1F1F1F] placeholder:text-sm placeholder:font-normal placeholder:text-[#1F1F1F] outline-none"
                                />
                                <img
                                    src="../../src/assets/images/search.svg"
                                    alt=""
                                    className="absolute top-[11px] right-[19px]"
                                />
                            </div>
                            <div className="relative">
                                <img
                                    src="../../src/assets/images/filter.svg"
                                    className="cursor-pointer"
                                    alt=""
                                />
                                <div className="pl-[18px] pr-[31px] absolute top-[40px] left-0 rounded-[10px] z-10 bg-white border border-black">
                                    <div className="flex space-x-[73px]">
                                        <h1 className="pt-2 text-base font-normal">Status</h1>
                                        <button className="text-base text-primary font-normal whitespace-nowrap">
                                            Clear all
                                        </button>
                                    </div>
                                    <div>
                                        <div className="px-2 py-2 block min-h-[1.5rem] pl-[1.5rem]">
                                            <input
                                                className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-[#9E2064] outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                                                type="checkbox"
                                                value="onboard_merchant"
                                                id=""
                                            />
                                            <label
                                                for=""
                                                className="inline-block pl-[1rem] hover:cursor-pointer text-base font-normal text-[#1F1F1F]"
                                            >
                                                Active
                                            </label>
                                        </div>
                                        <div className="px-2 py-2 block min-h-[1.5rem] pl-[1.5rem]">
                                            <input
                                                className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-[#9E2064] outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                                                type="checkbox"
                                                value="onboard_merchant"
                                                id=""

                                            />
                                            <label
                                                for=""
                                                className="inline-block pl-[1rem] hover:cursor-pointer text-base font-normal text-[#1F1F1F]"
                                            >
                                                Inactive
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <img
                                src="../../src/assets/images/plus.svg"
                                className="cursor-pointer"
                                alt=""
                            // onClick={() => addAdminNavigate("/addadminuser")}
                            />

                            {data.length > 1 && (
                                <button className="px-4 py-[10px] border border-[#9E2064] text-primary rounded-[12px]">
                                    Export
                                </button>
                            )}
                        </div>
                    </div>

                    {data.length > 1 ? (
                        <div>
                            <table className="w-full">
                                <thead>
                                    <tr className="border-b-[1px] border-[#EEEEEE]">
                                        <th className="flex space-x-1 px-4 py-3">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm">Merchant Name</h1>
                                            <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('name')}
                                                className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} />
                                        </th>
                                        <th className="px-4 py-3 text-left">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm text-left">Business Name</h1>
                                        </th>
                                        <th className="px-4 py-3">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm text-left">City</h1>
                                        </th>
                                        <th className=" px-4 py-3 ">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm text-left">Postal Code</h1>
                                        </th>
                                        <th className=" px-4 py-3">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm ">Number of Stores</h1>
                                        </th>
                                        <th className="flex space-x-1 px-4 py-3 justify-center">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm ">Status</h1>
                                            <img src="/assets/images/sort-pink.svg" alt="" onClick={() => handleSort('name')}
                                                className={`cursor-pointer ${CheckSort('status') ? 'rotate-180' : ''}`} />
                                        </th>
                                        <th className="px-4 py-3">
                                            <h1 className="text-[#4B4B4B] font-medium text-sm">Action</h1>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index} className="border-b-[1px] border-[#EEEEEE]">
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-left">
                                                    {item.merchant_name}
                                                </h1>
                                            </td>
                                            <td className="px-4 py-3 ">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-left">
                                                    {item.business_name}
                                                </h1>
                                            </td>
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-left">{item.city}</h1>
                                            </td>
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-left">
                                                    {item.postal_code}
                                                </h1>
                                            </td>
                                            <td className="px-4 py-3">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-center">
                                                    {item.number_of_stores}
                                                </h1>
                                            </td>
                                            <td className="px-4 py-3">
                                                {getStatusContent(item.status)}
                                            </td>
                                            <td className="px-4 py-3 flex justify-center">
                                                <h1 className="text-sm text-[#4B4B4B] font-normal text-center">{item.action}</h1>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <Noresult />
                    )}

                    {data.length > 1 && (
                        <div className="mt-[26px] pb-[85px] flex justify-end">
                            <div className="flex pr-[60px] pt-3 pb-4 space-x-2 ">
                                <img src="../../src/assets/images/Left.svg" alt="" />
                                <button className="px-[5px]">1</button>
                                <button className="px-[5px]">2</button>
                                <button className="px-[5px]">3</button>
                                <button className="px-[5px] bg-[#FBEBF4]">4</button>
                                <button className="px-[5px]">5</button>
                                <button className="px-[5px]">...</button>
                                <button className="px-[5px]">10</button>
                                <img src="../../src/assets/images/Right.svg" alt="" />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
